import { DEMAND_URL } from '../../../components/realtor_demand/constants/demand_url';
import { stringify } from 'qs';

export const openDemandForm = (bannerLocation: string) => {
  const queryString = stringify({ label: bannerLocation});

  window.open(`${DEMAND_URL}?${queryString}`, '_blank');
}
